module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAQCAYAAADwMZRfAAAAAXNSR0IArs4c6QAAASNJREFUOE/tkzFKA2EQhd/MRlRMflaIpvIIQbyBZcBKRNw12FiIHsDC2sLC0iJiYSebIGIlWHoDkRzBKhpx8yegYnZGDMSEVXYVLZ32Pb73mGEIKWN95E2AZpKN0iH8ZAIZ/y1ETSCJYd9p8g8B0F7EdHYKj3SEV+tzbye6gZHOPSZz57iLX+rLxVqf9wAtNkJdKrj83AhlrODSGUB1E8jOJ4iuYQK3eKErdPuiLsOxDp8QaRagBUAvVKljIinTKaIP3zwymMEotTw+IMi1qeJ4OGEAwooqanHAu9d6WFfwHLVXuRIJbtyqHMZr9kDMW0akMtyg7ws93nQYs4mQtJf4W0jL412CFgV0mZYc1xlaUlCdHsowmYi3mZH/KUQEza4j+282+o0sz9ZVJQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon34.png
// module id = XKw2
// module chunks = 1